import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Link,
  Typography,
} from '@mui/material'

import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import responsiveHook from '@hooks/useResponsive'

import { lineClamp } from '@utils/styles'
import { IBlogPost } from '@utils/types'

import {
  containerSx,
  contentSx,
  imageSx,
  readArticleButtonSx,
  titleSx,
} from './styles'

const BlogPostCard = ({
  title,
  type,
  preview,
  image,
  slug,
}: Pick<IBlogPost, 'title' | 'type' | 'preview' | 'image' | 'slug'>) => {
  const { t } = useTranslation()

  const { isMobile } = responsiveHook.useResponsive()

  const blogPostUrlLink = `/blog/${type}/${slug}`

  return (
    <Link
      data-testid="blog-post-item-link"
      component={RouterLink}
      to={blogPostUrlLink}
      underline="none"
    >
      <Card data-testid="blog-post-item" sx={containerSx}>
        <CardMedia
          alt={t('Blog Post Image')}
          component="img"
          loading="lazy"
          data-testid="blog-post-image"
          image={image as string}
          sx={imageSx}
        />
        <CardContent sx={contentSx}>
          <Typography data-testid="blog-post-title" variant="h5" sx={titleSx}>
            {title}
          </Typography>
          <Typography
            data-testid="blog-post-preview"
            sx={lineClamp({ lines: isMobile ? 3 : 2 })}
          >
            {preview}
          </Typography>
          <Button
            data-testid="blog-post-read-article-button"
            disableTouchRipple
            component="a"
            href={blogPostUrlLink}
            rel="noopener noreferrer"
            variant="text"
            size="medium"
            endIcon={<ArrowForwardIcon />}
            sx={readArticleButtonSx}
          >
            {t('Read Article')}
          </Button>
        </CardContent>
      </Card>
    </Link>
  )
}

export { BlogPostCard }
